module.exports = __webpack_public_path__ + "static/img_12-085083b1c80d5b1afd294cea1d504442.png";